import { HttpClient } from './httpClient'
import * as ApiEvents from './apiEvents'

export const getC88Form = (shipmentId, callback) => {
    const data = {
        eventMessage: shipmentId,
        eventType: ApiEvents.GET_C88_FORM_UK,
        eventTime: Date.now()
    }
    // console.log('GET_C88_FORM_UK ', data)

    return HttpClient.custom({
        data
    })
}

export const getDropdownValues = callback => {
    const data = {
        eventMessage: '',
        eventType: ApiEvents.GET_DROPDOWN_VALUES_UK,
        eventTime: Date.now()
    }
    return HttpClient.custom({
        data
    })
}


export const getDropdownValuesForUnitTpye = callback => {
    const data = {
        eventMessage: {
            country: "US",
            itemType: "UNITS_LIST",
            hsVersion: "2019Rev2.0"
        },
        eventType: ApiEvents.GET_HS_MASTER_HS,
        eventTime: Date.now()
    }
    return HttpClient.custom({
        data
    })
}



export const getDropdownValuesForProcedureCodeIm = (
  declarationType,
  callback
) => {
  const data = {
    eventMessage: {
      shipmentType: "IM",
    },
    eventType: ApiEvents.GET_PROCEDURE_CODE_VALUES,
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getDropdownValuesForProcedureCodeEx = (
  declarationType,
  callback
) => {
  const data = {
    eventMessage: {
      shipmentType: "EX",
    },
    eventType: ApiEvents.GET_PROCEDURE_CODE_VALUES,
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};


export const getDropdownValuesForAdditionalDocCodeHeaderIm = (
  declarationType,
  callback
) => {
  const data = {
    eventMessage: {
      declarationType: "Import",
      consumer:"Header",
      aiType:ApiEvents.AI_DETAIL_DOCS
    },
    eventType: ApiEvents.GET_AI_VALUES,
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getDropdownValuesForAdditionalDocCodeHeaderEx = (
  declarationType,
  callback
) => {
  const data = {
    eventMessage: {
      declarationType: "Export" ,
      consumer:"Header",
      aiType:ApiEvents.AI_DETAIL_DOCS
    },
    eventType: ApiEvents.GET_AI_VALUES,
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};


export const getDropdownValuesForAdditionalDocCodeItemsIm = (

) => {
  const data = {
    eventMessage: {
      declarationType:  "Import" ,
      consumer:"Item",
      aiType:ApiEvents.AI_DETAIL_DOCS
    },
    eventType: ApiEvents.GET_AI_VALUES,
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getDropdownValuesForAdditionalDocCodeItemsEx = (

) => {
  const data = {
    eventMessage: {
      declarationType:  "Export" ,
      consumer:"Item",
      aiType:ApiEvents.AI_DETAIL_DOCS
    },
    eventType: ApiEvents.GET_AI_VALUES,
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};


export const getDropdownValuesForAICodeHeaderIm = (

  callback
) => {
  const data = {
    eventMessage: {
      declarationType: "Import" ,
      consumer:"Header",
      aiType:ApiEvents.AI_DETAIL_STATEMENT
    },
    eventType: ApiEvents.GET_AI_VALUES,
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getDropdownValuesForAICodeHeaderEx = (

) => {
  const data = {
    eventMessage: {
      declarationType: "Export" ,
      consumer:"Header",
      aiType:ApiEvents.AI_DETAIL_STATEMENT
    },
    eventType: ApiEvents.GET_AI_VALUES,
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};
export const getDropdownValuesForAICodeItemsIm = (
  declarationType,
  callback
) => {
  const data = {
    eventMessage: {
      declarationType: "Import",
      consumer:"Item",
      aiType:ApiEvents.AI_DETAIL_STATEMENT
    },
    eventType: ApiEvents.GET_AI_VALUES,
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getDropdownValuesForAICodeItemsEx = (
  declarationType,
  callback
) => {
  const data = {
    eventMessage: {
      declarationType: "Export" ,
      consumer:"Item",
      aiType:ApiEvents.AI_DETAIL_STATEMENT
    },
    eventType: ApiEvents.GET_AI_VALUES,
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};





export const getShipmentNotes=(shipmentId)=>{
  const data = {
    eventMessage: {
      shipmentId } ,
    eventType: ApiEvents.GET_SHIPMENT_NOTES,
    eventTime: Date.now()
}

return HttpClient.custom({
  data
})
}
export const getDataError =(shipmentid)=>{
  const data = {
    eventMessage: {
      shipmentid } ,
    eventType: "VALIDATE_UK_FORM",
    eventTime: Date.now()
}

return HttpClient.custom({
    data
})
}

